// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"43106302","323":"d357996b","490":"248800d0","869":"f48b4bc5"}[chunkId] + ".chunk.js";
};